/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 2dMe7XWUq916KsPnra5vYj
// Component: OKf_hhc2Skl

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  generateStateOnChangeProp,
  generateStateValueProp,
  hasVariant,
  PlasmicIcon as PlasmicIcon__,
  renderPlasmicSlot,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
  useTrigger,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import MenuButton from "../../components/widgets/MenuButton"; // plasmic-import: h69wHrrKtL/component
import Select from "../../components/widgets/Select"; // plasmic-import: j_4IQyOWK2b/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_end_user_management.css"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/projectcss
import sty from "./PlasmicPermissionRule.module.css"; // plasmic-import: OKf_hhc2Skl/css

import LockIcon from "../plasmic_kit_design_system/PlasmicIcon__Lock"; // plasmic-import: xWjo2JPAc6/icon
import InformationSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__InformationSvg"; // plasmic-import: hqBNVBJWB/icon
import PlusSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__PlusSvg"; // plasmic-import: sQKgd2GNr/icon
import UsersSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__UsersSvg"; // plasmic-import: SQUWUgO0N/icon
import UserSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__UserSvg"; // plasmic-import: ejczgMIkT/icon

createPlasmicElementProxy;

export type PlasmicPermissionRule__VariantMembers = {
  isGroup: "isGroup";
  hasMenu: "hasMenu";
  withoutBorder: "withoutBorder";
  isGeneralAccess: "isGeneralAccess";
};
export type PlasmicPermissionRule__VariantsArgs = {
  isGroup?: SingleBooleanChoiceArg<"isGroup">;
  hasMenu?: SingleBooleanChoiceArg<"hasMenu">;
  withoutBorder?: SingleBooleanChoiceArg<"withoutBorder">;
  isGeneralAccess?: SingleBooleanChoiceArg<"isGeneralAccess">;
};
type VariantPropType = keyof PlasmicPermissionRule__VariantsArgs;
export const PlasmicPermissionRule__VariantProps = new Array<VariantPropType>(
  "isGroup",
  "hasMenu",
  "withoutBorder",
  "isGeneralAccess"
);

export type PlasmicPermissionRule__ArgsType = { ruleName?: React.ReactNode };
type ArgPropType = keyof PlasmicPermissionRule__ArgsType;
export const PlasmicPermissionRule__ArgProps = new Array<ArgPropType>(
  "ruleName"
);

export type PlasmicPermissionRule__OverridesType = {
  root?: Flex__<"div">;
  infoIcon?: Flex__<"svg">;
  permissionSelect?: Flex__<typeof Select>;
  menuBtn?: Flex__<typeof MenuButton>;
};

export interface DefaultPermissionRuleProps {
  ruleName?: React.ReactNode;
  isGroup?: SingleBooleanChoiceArg<"isGroup">;
  hasMenu?: SingleBooleanChoiceArg<"hasMenu">;
  withoutBorder?: SingleBooleanChoiceArg<"withoutBorder">;
  isGeneralAccess?: SingleBooleanChoiceArg<"isGeneralAccess">;
  className?: string;
}

const $$ = {};

function PlasmicPermissionRule__RenderFunc(props: {
  variants: PlasmicPermissionRule__VariantsArgs;
  args: PlasmicPermissionRule__ArgsType;
  overrides: PlasmicPermissionRule__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "isGroup",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isGroup,
      },
      {
        path: "hasMenu",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.hasMenu,
      },
      {
        path: "withoutBorder",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.withoutBorder,
      },
      {
        path: "isGeneralAccess",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.isGeneralAccess,
      },
      {
        path: "permissionSelect.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const [isRootHover, triggerRootHoverProps] = useTrigger("useHover", {});
  const triggers = {
    hover_root: isRootHover,
  };

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_2dMe7XWUq916KsPnra5vYj",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.roothasMenu]: hasVariant($state, "hasMenu", "hasMenu"),
          [sty.rootisGeneralAccess]: hasVariant(
            $state,
            "isGeneralAccess",
            "isGeneralAccess"
          ),
          [sty.rootisGroup]: hasVariant($state, "isGroup", "isGroup"),
          [sty.rootwithoutBorder]: hasVariant(
            $state,
            "withoutBorder",
            "withoutBorder"
          ),
        }
      )}
      data-plasmic-trigger-props={[triggerRootHoverProps]}
    >
      <div
        className={classNames("all", sty.column__jfo1K, {
          [sty.columnhasMenu__jfo1K8Gjcf]: hasVariant(
            $state,
            "hasMenu",
            "hasMenu"
          ),
          [sty.columnisGeneralAccess__jfo1K2XHMe]: hasVariant(
            $state,
            "isGeneralAccess",
            "isGeneralAccess"
          ),
          [sty.columnwithoutBorder__jfo1Kk0M9C]: hasVariant(
            $state,
            "withoutBorder",
            "withoutBorder"
          ),
        })}
      >
        <div className={classNames("all", sty.freeBox__xxViF)}>
          <PlasmicIcon__
            PlasmicIconType={
              hasVariant($state, "isGeneralAccess", "isGeneralAccess")
                ? LockIcon
                : hasVariant($state, "isGroup", "isGroup")
                ? UsersSvgIcon
                : UserSvgIcon
            }
            className={classNames("all", sty.svg__hcvJq, {
              [sty.svgisGeneralAccess__hcvJq2XHMe]: hasVariant(
                $state,
                "isGeneralAccess",
                "isGeneralAccess"
              ),
              [sty.svgisGroup__hcvJqX7CpY]: hasVariant(
                $state,
                "isGroup",
                "isGroup"
              ),
            })}
            role={"img"}
          />

          <div
            className={classNames("all", sty.freeBox__j4Sj, {
              [sty.freeBoxisGeneralAccess__j4Sj2XHMe]: hasVariant(
                $state,
                "isGeneralAccess",
                "isGeneralAccess"
              ),
            })}
          >
            {renderPlasmicSlot({
              defaultContents: "Anonymous visitors",
              value: args.ruleName,
              className: classNames(sty.slotTargetRuleName),
            })}
            <InformationSvgIcon
              data-plasmic-name={"infoIcon"}
              data-plasmic-override={overrides.infoIcon}
              className={classNames("all", sty.infoIcon, {
                [sty.infoIconisGeneralAccess]: hasVariant(
                  $state,
                  "isGeneralAccess",
                  "isGeneralAccess"
                ),
              })}
              role={"img"}
            />
          </div>
        </div>
      </div>
      <div
        className={classNames("all", sty.column__ab9P, {
          [sty.columnhasMenu__ab9P8Gjcf]: hasVariant(
            $state,
            "hasMenu",
            "hasMenu"
          ),
        })}
      >
        <div
          className={classNames("all", sty.freeBox__e95EI, {
            [sty.freeBoxhasMenu__e95EI8Gjcf]: hasVariant(
              $state,
              "hasMenu",
              "hasMenu"
            ),
          })}
        >
          <Select
            data-plasmic-name={"permissionSelect"}
            data-plasmic-override={overrides.permissionSelect}
            className={classNames("__wab_instance", sty.permissionSelect, {
              [sty.permissionSelecthasMenu]: hasVariant(
                $state,
                "hasMenu",
                "hasMenu"
              ),
              [sty.permissionSelectisGeneralAccess]: hasVariant(
                $state,
                "isGeneralAccess",
                "isGeneralAccess"
              ),
              [sty.permissionSelectisGroup]: hasVariant(
                $state,
                "isGroup",
                "isGroup"
              ),
              [sty.permissionSelectwithoutBorder]: hasVariant(
                $state,
                "withoutBorder",
                "withoutBorder"
              ),
            })}
            icon={
              <PlusSvgIcon
                className={classNames("all", sty.svg__boPRj)}
                role={"img"}
              />
            }
            onChange={async (...eventArgs: any) => {
              ((...eventArgs) => {
                generateStateOnChangeProp($state, [
                  "permissionSelect",
                  "value",
                ])(eventArgs[0]);
              }).apply(null, eventArgs);

              if (
                eventArgs.length > 1 &&
                eventArgs[1] &&
                eventArgs[1]._plasmic_state_init_
              ) {
                return;
              }
            }}
            size={"small"}
            type={
              hasVariant($state, "isGroup", "isGroup") ? "seamless" : "seamless"
            }
            value={generateStateValueProp($state, [
              "permissionSelect",
              "value",
            ])}
          />

          <MenuButton
            data-plasmic-name={"menuBtn"}
            data-plasmic-override={overrides.menuBtn}
            className={classNames("__wab_instance", sty.menuBtn, {
              [sty.menuBtnhasMenu]: hasVariant($state, "hasMenu", "hasMenu"),
            })}
          />
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "infoIcon", "permissionSelect", "menuBtn"],
  infoIcon: ["infoIcon"],
  permissionSelect: ["permissionSelect"],
  menuBtn: ["menuBtn"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  infoIcon: "svg";
  permissionSelect: typeof Select;
  menuBtn: typeof MenuButton;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicPermissionRule__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicPermissionRule__VariantsArgs;
    args?: PlasmicPermissionRule__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicPermissionRule__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicPermissionRule__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPermissionRule__ArgProps,
          internalVariantPropNames: PlasmicPermissionRule__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicPermissionRule__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPermissionRule";
  } else {
    func.displayName = `PlasmicPermissionRule.${nodeName}`;
  }
  return func;
}

export const PlasmicPermissionRule = Object.assign(
  // Top-level PlasmicPermissionRule renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    infoIcon: makeNodeComponent("infoIcon"),
    permissionSelect: makeNodeComponent("permissionSelect"),
    menuBtn: makeNodeComponent("menuBtn"),

    // Metadata about props expected for PlasmicPermissionRule
    internalVariantProps: PlasmicPermissionRule__VariantProps,
    internalArgProps: PlasmicPermissionRule__ArgProps,
  }
);

export default PlasmicPermissionRule;
/* prettier-ignore-end */
